<template>
  <div class="frisbuy-summary-widget__anchor" @click="emit('swipeToMarket')">
    {{ props.text }}
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ text: string }>();
const emit = defineEmits(["swipeToMarket"]);
</script>
